import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cadastrar-fornecedor',
  templateUrl: './cadastrar-fornecedor.component.html',
  styleUrls: ['./cadastrar-fornecedor.component.scss'],
})
export class CadastrarFornecedorComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
